import { useUserOrganization } from '@modules-deprecated/app/organization'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { InvoiceComplianceMode } from '../enums/invoiceComplianceMode'

type ComplianceMarkets = Extract<Organization['countryId'], 'FR'> // possibly extended with 'DE' | 'NL' | 'DK' in the future

const invoiceComplianceModeByCountry: Record<ComplianceMarkets, InvoiceComplianceMode> = {
  FR: InvoiceComplianceMode.French,
}

const isComplianceMarket = (id: Organization['countryId']): id is ComplianceMarkets =>
  id in invoiceComplianceModeByCountry

export const useInvoiceComplianceMode = () => {
  const { isLoading, organization } = useUserOrganization()

  const invoiceComplianceMode =
    organization?.countryId && isComplianceMarket(organization.countryId)
      ? invoiceComplianceModeByCountry[organization.countryId]
      : InvoiceComplianceMode.Default

  return {
    invoiceComplianceMode,
    isFrenchComplianceMode: invoiceComplianceMode === InvoiceComplianceMode.French,
    isLoading,
  }
}
